import React from "react";
import toast from "react-hot-toast";
import { webTemp } from "../../../Utils/styles";

const Mobile = () => {
  const LinkApp = [
    {
      image: window.origin + "/WebSide/assets/images/bazzar.png",
      url: "https://cafebazaar.ir/app/ir.nikotani",
    },
    {
      image: window.origin + "/WebSide/assets/images/google-play.png",
      url: "",
    },
    {
      image: window.origin + "/WebSide/assets/images/myket.png",
      url: "https://myket.ir/app/ir.nikotani",
    },
  ];
  return (
    <section
      className="mobile2-section mt-4 mt-lg-5 px-0 px-sm-2 mb-5 web-temp py-3 py-md-4 py-lg-5"
      id="mobile2"
      // style={{ ...webTemp }}
    >
      <div className="container-fluid px-3 ">
        <div className="row">
          <div className="col-md-6 ">
            <div className="d-flex align-items-center">
              <img
                className="me-1 me-md-2"
                src={window.origin + "/WebSide/assets/images/app-icon.png"}
                alt="nikotan | نیکوتن"
              />
              <h4
                style={{
                  color: "#0f0f0f",
                  fontWeight: "400",
                }}
                className="fw-bolder py-4"
              >
                همین الان اپلیکیشن نیکوتن را دانلود کنید
              </h4>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row justify-content-end" style={{ height: "100%" }}>
              {LinkApp.map((linkapp, i) => {
                return (
                  <button
                    key={i}
                    className="mb-2 mb-xl-0"
                    target={linkapp.url === "" ? "" : "_blank"}
                    href={linkapp.url === "" ? undefined : linkapp.url}
                    onClick={() =>
                      linkapp.url === ""
                        ? toast.success("به زودی در دسترس قرار میگیرد")
                        : window.open(
                            linkapp.url,
                            "_blank",
                            "noopener,noreferrer"
                          )
                    }
                  >
                    <img
                      src={linkapp.image}
                      alt="nikotan | نیکوتن"
                      className="img-fluid"
                    />
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mobile;
